export default __webpack_public_path__ + "static/media/logo11.998b04a9.svg";